import { HeadTypeDescription } from '@/api/models/TourBagMstrPayload';
import { IActivePlayer } from '@/db/repositories/ActivePlayerRepo';
import { headTypeMap } from '@/constants';
import { isIOSWebView } from './isIOSWebView';

export const createEmptyTourBag = (headType: HeadTypeDescription, player: IActivePlayer) => ({
  tourBagMstrId: -1,
  playerId: player.playerId,
  playerName: player.fullName,
  tourId: player.defaultTourId,
  tourName: player.defaultTourName,
  headTypeId: headTypeMap[headType],
  headTypeDescription: headType,
  editSource: isIOSWebView ? 'iOS' : 'web',
  isBsg: false, // TODO: Update for BSG if required
  isBagEmpty: true,
  notes: '',
  tourBagDetail: [],
  tourBagBsg: [],
  tourBagIronDetail: [],
  tourBagIronSets: [],
  // Shared Model props
  isActive: false,
  modifyDate: new Date(),
  modifyUserGuid: '',
  modifyUserName: '',
  createDate: new Date(),
  createUserGuid: '',
  rowGuid: '',
  tstamp: '',
});
